module.exports = __webpack_public_path__ + "static/mockprod-5f5e2816e6d4558b3aa0ce6cf1bf84d7.png";